import React from 'react';
import {
  Field,
  Select,
  SelectItem,
  SelectTrigger,
  Spinner,
} from '@billda/design-system';
import { useLabourItemGroups } from '../hooks/useLabourItemGroups';

interface LabourGroupSelectProps {
  value?: number | null;
  onChange: (groupId: number | null) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
}

const NONE_VALUE = '__none__';

export const LabourGroupSelect: React.FC<LabourGroupSelectProps> = ({
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  error = false,
  helperText,
}) => {
  const { data: groups = [], isLoading } = useLabourItemGroups();

  return (
    <div className={`relative ${fullWidth ? 'w-full' : ''}`}>
      <Field error={error ? (helperText ?? ' ') : undefined}>
        <Select
          value={value != null ? String(value) : NONE_VALUE}
          onValueChange={newValue => {
            if (newValue === NONE_VALUE) {
              onChange(null);
            } else {
              onChange(Number(newValue));
            }
          }}
          disabled={disabled || isLoading}
          data-testid="labour-group-select"
        >
          <SelectTrigger aria-label="Labour group" />
          <SelectItem value={NONE_VALUE}>
            <em>None</em>
          </SelectItem>
          {groups.map(group => (
            <SelectItem key={group.id} value={String(group.id)}>
              {group.name}
            </SelectItem>
          ))}
        </Select>
      </Field>
      {helperText && !error && (
        <p className="mt-1.5 type-caption text-content-secondary">
          {helperText}
        </p>
      )}
      {isLoading && (
        <Spinner size={20} className="absolute right-9 top-1/2 -mt-2.5" />
      )}
    </div>
  );
};
